import { MenuAlt2Icon } from '@heroicons/react/outline';
import PropTypes from 'prop-types';
import * as React from 'react';
import { MobileSidebar } from './components/MobileSidebar';
import { Sidebar } from './components/Sidebar';
import { UserNavigation } from './components/UserNavigation';
import { useAuth } from 'lib/auth';
import { MdOpenInNew } from 'react-icons/md';
import logo from 'assets/pratham-logo.webp';

export const MainLayout = ({ children }) => {
  const { user } = useAuth();
  const [sidebarOpen, setSidebarOpen] = React.useState(false);

  const currentDate = new Date();
  const currentYear = currentDate.getFullYear();

  return (
    <div className="h-screen flex overflow-hidden bg-white">
      <MobileSidebar sidebarOpen={sidebarOpen} setSidebarOpen={setSidebarOpen} />
      <Sidebar />
      <div className="bg-gray-100 flex flex-col w-0 flex-1 overflow-hidden">
        <div className="bg-gray-800 relative z-10 items-center flex-shrink-0 flex h-16">
          <div className="px-10 text-xs text-gray-200 font-bold truncate overflow-hidden">
            <span className="text-[#50CAF3]">
              {user?.firstName} {user?.lastName}
            </span>{' '}
            currently logged in.
          </div>
          <button
            className="px-4 border-r border-gray-200 text-gray-500 focus:outline-none focus:ring-2 focus:ring-inset focus:ring-indigo-500 md:hidden"
            onClick={() => setSidebarOpen(true)}
          >
            <span className="sr-only">Open sidebar</span>
            <MenuAlt2Icon className="h-6 w-6" aria-hidden="true" />
          </button>
          <div className="flex-1 px-4 flex justify-end">
            <div className="ml-4 flex items-center md:ml-6">
              <a href="https://dashboard.tawk.to/login" target="_blank">
                <div className="flex flex-row items-center space-x-2 rounded-full border border-gray-700 hover:bg-gray-700 p-1 px-3">
                  <MdOpenInNew className="text-gray-100" />
                  <div className="text-gray-100">Go to Tawk</div>
                </div>
              </a>
            </div>
            <div className="ml-4 flex items-center md:ml-6">
              <UserNavigation />
            </div>
          </div>
        </div>
        <main className="flex flex-col flex-1 relative overflow-y-auto focus:outline-none">
          <div className="flex-1 bg-gray-800">
            <div className={`rounded-tl-3xl rounded-bl-3xl bg-gray-100 min-h-[86vh]`}>
              {children}
            </div>
          </div>
          <footer className="bg-gray-800 flex flex-row items-center justify-between p-4">
            <div className="px-10 text-xs text-gray-100 truncate overflow-hidden">
              All rights reserved © With Love Uganda {currentYear} | Built with ❤️{' '}
              <a href="https://ashitacreatives.com" target="_blank" rel="noreferrer">
                Ashita Creatives.
              </a>
            </div>
            <div className="flex flex-row items-center space-x-2">
              <img className="h-6 w-auto" src={logo} alt="Workflow" />
            </div>
          </footer>
        </main>
      </div>
    </div>
  );
};

MainLayout.propTypes = {
  children: PropTypes.node.isRequired,
};
